module.exports = __webpack_public_path__ + "h5/img/master_11.0313edb1.jpg";